import CropperModalProvider, {
  useCropperModalState,
  useCropperModalActions,
} from './Provider';

export { useCropperModalState, useCropperModalActions };

export default CropperModalProvider;
